export default {
  name: 'BottomTip',
  components: {},

  setup() {
    return {};
  }

};